import React, { Component } from "react";

import { connect } from "react-redux";

import { Link } from "react-router-dom";

// reactstrap
import {
  Form,
  Input,
  Button,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

// Import menuDropdown
// import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import ProfileMenu from "./ProfileMenu";

//Import Logos
// import xchoolLogo from "../../assets/images/xchools-logo-.png"
import Brandstrek from "../../assets/images/brandstrek-logo.png";

// profile images
// import exams from "../../assets/images/icons/exams.png";
// import attendance from "../../assets/images/icons/calender.png";
// import homeworks from "../../assets/images/icons/homeworks.png";

//Import mega menu image
// import megamenuImg from "../../assets/images/megamenu-img.png";

// Redux Store
import { toggleRightSidebar } from "../../store/actions";
import NotificationDropdown from "./NotificationDropdown";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      isMegaMenu: false,
      isProfile: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleRightbar = this.toggleRightbar.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
  }

  toggleSearch = () => {
    this.setState({ isSearch: !this.state.isSearch });
  };
  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.openLeftMenuCallBack();
  }

  /**
   * Toggles the sidebar
   */
  toggleRightbar() {
    this.props.toggleRightSidebar();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header ">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={Brandstrek} alt="" height="30" />
                </span>
                <span className="logo-lg">
                  <img src={Brandstrek} alt="" height="30" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={Brandstrek} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={Brandstrek} alt="" height="20" />
                </span>
              </Link>
            </div>

            <div className="d-flex">
              <Button
                color="none"
                type="button"
                size="sm"
                onClick={this.toggleMenu}
                className="px-3 font-size-24 d-lg-none header-item"
                data-toggle="collapse"
                data-target="#topnav-menu-content"
              >
                <i className="ri-menu-2-line align-middle"></i>
              </Button>

              <Form className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <Input
                    type="text"
                    className="form-control"
                    placeholder={this.props.t("Search")}
                  />
                  <span className="ri-search-line"></span>
                </div>
              </Form>

              <div className="dropdown d-inline-block d-lg-none ms-2">
                {/* <Button
                  color="none"
                  type="button"
                  onClick={() => {
                    this.setState({ isSearch: !this.state.isSearch });
                  }}
                  className="header-item noti-icon waves-effect"
                  id="page-header-search-dropdown"
                >
                  <i className="ri-search-line"></i>
                </Button> */}
                {/* <div
                  className={
                    this.state.isSearch
                      ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                      : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                  }
                  aria-labelledby="page-header-search-dropdown"
                >
                  <Form className="p-3">
                    <FormGroup className="m-0">
                      <InputGroup>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder={this.props.t("Search")}
                        />
                        <div className="input-group-append">
                          <Button color="primary" type="submit">
                            <i className="ri-search-line"></i>
                          </Button>
                        </div>
                      </InputGroup>
                    </FormGroup>
                  </Form>
                </div> */}
              </div>

              {/* <LanguageDropdown /> */}

              {/* <Dropdown isOpen={this.state.isProfile} toggle={() => this.setState({ isProfile: !this.state.isProfile })} className="d-none d-lg-inline-block ms-1">
                                    <DropdownToggle tag="button" type="button" className="btn header-item noti-icon waves-effect">
                                        <i className="ri-apps-2-line"></i>
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-end dropdown-menu-lg">
                                        <div className="px-lg-2">
                                            <Row className="g-0">
                                                <Col>
                                                    <Link to="/parent/attendance" className="dropdown-icon-item">
                                                        <img src={attendance} alt="attendance" style={{ width: "30px", height: "30px"}}/>
                                                        <span>{this.props.t('Attendance')}</span>
                                                    </Link>
                                                </Col>
                                                <Col>
                                                    <Link to="/parent/exams" className="dropdown-icon-item">
                                                        <img src={exams} alt="exams" style={{ width: "30px", height: "30px"}}/>
                                                        <span>{this.props.t('Exams')}</span>
                                                    </Link>
                                                </Col>
                                                <Col>
                                                    <Link to="/parent/homework" className="dropdown-icon-item">
                                                        <img src={homeworks} alt="homeworks" style={{ width: "30px", height: "30px"}}/>
                                                        <span>{this.props.t('Homeworks')}</span>
                                                    </Link>
                                                </Col>
                                            </Row>

                                           
                                        </div>
                                    </DropdownMenu>
                                </Dropdown> */}

              {/* <div className="dropdown d-none d-lg-inline-block ms-1">
                                    <Button type="button" color="none" onClick={this.toggleFullscreen} className="header-item noti-icon waves-effect" data-toggle="fullscreen">
                                        <i className="ri-fullscreen-line"></i>
                                    </Button>
                                </div> */}

              <NotificationDropdown />

              <ProfileMenu />
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(
  withTranslation()(Header)
);
